// core
import {Component} from "@angular/core";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";

// constants
import {AppConstants} from "app/utils/constants";

// services
import {UserRegistrationServiceService} from "app/user-registration/service/user-registration-service.service";
import {UtilsService} from "app/utils/utils.service";
import {ErrorMessageService} from "../../../../core/alert-message/alert-message.service";


@Component({
    selector: 'target-group-modal',
    templateUrl: './target-group-modal.component.html',
    styleUrls: ['./target-group-modal.component.scss'],
    standalone: false
})
export class TargetGroupModal {

  // input values
  public currentFlow: string;
  public customerName: string;
  public userId;
  public preselectedTargetGroup: string;
  public callBack;
  private data;

  // navigation modal references
  public rolesModalRef: BsModalRef;

  public targetGroupForm: UntypedFormGroup;
  private targetGroups;
  private listOfTargetGroups: Array<any> = new Array<any>();
  private addUserFlow: string = AppConstants.CREATE_MODE;
  private editUserFlow: string = AppConstants.EDIT_MODE;

  constructor(
    public targetGroupModalRef: BsModalRef,
    private _formBuilder: UntypedFormBuilder,
    private _translateService: TranslateService,
    private _utilsService: UtilsService,
    private _modalService: BsModalService,
    private _userRegistrationService: UserRegistrationServiceService,
    private errorMessageService: ErrorMessageService,
  ) {

    _translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.listOfTargetGroups = this._utilsService.initializeSelectOrMultiselect(this.targetGroups);
    });

    // output values
    this.targetGroupForm = this._formBuilder.group({
      targetGroup: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ]
    });
  }

  ngOnInit() {
    this._userRegistrationService.getTargetGroups().subscribe((response) => {
      this.targetGroups = response;

      if (this.customerName != null) {
        this.targetGroups = this._removeQualityPartnerPrivateCustomerAndOthersFromTargetGroups(this.targetGroups);
      } else {
        this.targetGroups = this._removeQualityPartnerFromTargetGroups(this.targetGroups);
      }

      this.listOfTargetGroups = this._utilsService.initializeSelectOrMultiselect(this.targetGroups);

      if (this.preselectedTargetGroup) {
        this.targetGroupForm.controls['targetGroup'].setValue(this.preselectedTargetGroup);
      }
      }, (error) => {
        // OpenErrorModal
        this.errorMessageService.openErrorModal(error);
    });
  }

  public getListOfTargetGroups() {
    return this.listOfTargetGroups;
  }

  public getAddUserFlow() {
    return this.addUserFlow;
  }

  public getEditUserFlow() {
    return this.editUserFlow;
  }


  public goToNextStep() {
    this.targetGroupModalRef.hide();
    this.data = {
      targetGroup: this.targetGroupForm.controls['targetGroup'].value,
      userId: this.userId
    };
    this.callBack(AppConstants.targetGroupModal, this.data);
  }

  private _removeQualityPartnerFromTargetGroups(targetGroups: Array<string>) {
    let resultedTargetGroups = targetGroups.filter(targetGroup =>
      (targetGroup !== AppConstants.qualityPartner)
    );
    return resultedTargetGroups;
  }

  private _removeQualityPartnerPrivateCustomerAndOthersFromTargetGroups(targetGroups: Array<string>) {
    let resultedTargetGroups = targetGroups.filter(targetGroup =>
      (targetGroup !== AppConstants.qualityPartner && targetGroup !== AppConstants.privateCustomer && targetGroup !== AppConstants.others)
    );
    return resultedTargetGroups;
  }
}
